/**
 * Troca de idioma: PT | ES, lado a lado.
 *
 * O idioma já vem certo pelo endereço — `.com.py` abre em espanhol, `.com.br`
 * em português —, então este botão é para a exceção: o brasileiro que opera a
 * portaria de Ciudad del Este, o paraguaio que trabalha no evento em Foz. Por
 * isso ele é discreto e fica onde o turno começa (login e abertura do caixa),
 * não no meio da validação.
 *
 * Os dois aparecem juntos, em vez de um botão que alterna: com um só, o
 * operador não sabe se "ES" é o idioma de agora ou o que vai virar. Assim ele
 * vê qual está aceso e toca no outro.
 */

import React from 'react';
import {Pressable, Text, View} from 'react-native';
import {Languages} from 'lucide-react-native';

import {definirIdioma, useIdioma, type Idioma} from './idioma';
import {fontes, useTema} from './tema';

const NOMES: Record<Idioma, string> = {pt: 'PT', es: 'ES'};

export function BotaoIdioma() {
  const t = useTema();
  const atual = useIdioma();

  return (
    <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 8}}>
      <Languages size={14} color={t.textoApagado} strokeWidth={2} />
      <View
        style={{
          flexDirection: 'row',
          borderRadius: 8,
          borderWidth: 1,
          borderColor: t.borda,
          overflow: 'hidden',
        }}>
        {(['pt', 'es'] as const).map(qual => {
          const aceso = qual === atual;
          return (
            <Pressable
              key={qual}
              onPress={() => definirIdioma(qual)}
              accessibilityRole="button"
              accessibilityState={{selected: aceso}}
              accessibilityLabel={qual === 'pt' ? 'Português' : 'Español'}
              style={{
                paddingHorizontal: 12,
                paddingVertical: 5,
                backgroundColor: aceso ? t.primaria : 'transparent',
              }}>
              <Text
                style={{
                  color: aceso ? t.tintaPrimaria : t.textoApagado,
                  fontSize: 12,
                  fontFamily: aceso ? fontes.negrito : fontes.regular,
                  letterSpacing: 0.6,
                }}>
                {NOMES[qual]}
              </Text>
            </Pressable>
          );
        })}
      </View>
    </View>
  );
}
